import type { IconSvgObject } from './types';

const BookDashedIcon: IconSvgObject = [
  ["path", { d: "M20 22H17M4 20C4 18.8954 4.89543 18 6 18H7M4 20C4 21.1046 4.89543 22 6 22H7M4 20V15.5M17 18H20V15M17 2H20V5M20 9V11M7 2H6C4.89543 2 4 2.89543 4 4V5M13 2H11M4 9V11M11 18H13M11 22H13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.5 18C19.5 18 18.5 18.7628 18.5 20C18.5 21.2372 19.5 22 19.5 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BookDashedIcon;
